import { NgModule } from '@angular/core';
import { AdminRoutingModule } from './AdminRouter/admin-routing.module';
import { AccountManagementComponent } from './AccountManagement/components/account-management.component';
import { AccountManagementModule } from './AccountManagement/account-management.module';
import { AccountManagementService } from './AccountManagement/services/account-management.service';
import { SystemNotificationsModule } from './SystemNotifications/system-notifications.module';
import { LeftSidebarService } from '../Common/Layout/services/left-sidebar.service';
import { AgentsApiService } from '../api/agents/agents.api';

@NgModule({
    imports: [
        AdminRoutingModule,
        AccountManagementModule,
        SystemNotificationsModule
    ],
    providers: [
        AccountManagementService,
        AgentsApiService,
        {
            provide: LeftSidebarService,
            useExisting: AccountManagementService
        }
    ],
    exports: [
        AccountManagementComponent,
    ]
})
export class AdminModule { }
